import api from './api';

export const salesOfferService = {
  async getOffers(params = {}) {
    const response = await api.get('/ventas/offers', { params });
    return response.data;
  },

  async getOffer(id) {
    const response = await api.get(`/ventas/offers/${id}`);
    return response.data;
  },

  async previewOffer(data) {
    const response = await api.post('/ventas/offers/preview', data);
    return response.data;
  },

  async createOffer(data) {
    const response = await api.post('/ventas/offers', data);
    return response.data;
  },

  async updateOffer(id, data) {
    const response = await api.put(`/ventas/offers/${id}`, data);
    return response.data;
  },

  async toggleOffer(id) {
    const response = await api.delete(`/ventas/offers/${id}`);
    return response.data;
  },
};

export default salesOfferService;
